<div class="text-center">
  <h1 class="display-4">Successfully logged out.</h1>
  <h3>To login again, visit your Launch Application and navigate to Instant Pay.</h3>
</div>
